<template>
  <div>
    <menu-pae/>

    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item">
                <router-link to="/workArea">Home</router-link>
              </li>
              <li class="breadcrumb-item">Setor</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>

    <div class="container-fluid mt-2">
      <filtro-pesquisa-setor class="p-2"
                             :rowsNumber="10"
                             :eventBusDataName="eventBusDataName"
                             :eventBusPaginationName="eventBusPaginationName"/>
    </div>

    <div class="container-xl">
      <data-table-consulta-comp
        :colNames="colNames"
        :eventBusDataName="eventBusDataName"
        :eventBusDataPaginationName="eventBusPaginationName"
        :renderizarCheckBox=true
        :dataTableColumn="dataTableColumn"
        :colWidth="colWidth"
        :disableCheckbox="disableCheckbox"
        :subtable="subtable">
        <template v-slot="slotProps">
          <td style="text-align: center; width: 100px !important; white-space: nowrap;">
            <i
              v-tooltip.auto-start="`Protocolo atribuído para ${slotProps.itemData.participanteAtual.titulo}`"
              v-if="disableAction(slotProps.itemData)"
              class="fa fa-user fa-1-5x text-info"
              aria-hidden="true"
            ></i>
            <i
              v-if="disableButtomVisualizar(slotProps.itemData)"
              v-tooltip.auto-start="`Visualizar Protocolo ${slotProps.itemData.processo}`"
              class="fa fa-search fa-1-5x m-1 link text-info"
              aria-hidden="true"
              v-on:click="visualizar(slotProps.itemData)"
            ></i>
            <i
              v-if="disableAction(slotProps.itemData)"
              class="fa fa-backward fa-1-5x link m-1 text-warning"
              aria-hidden="true"
              v-on:click="desatribuir(slotProps.itemData)"
            ></i>
          </td>
        </template>
        <template v-slot:subtable="subtable">
          <i
            v-tooltip.auto-start="`Visualizar protocolo ${subtable.itemData.data ? subtable.itemData.data.protocolo : ''}`"
            class="fa fa-search fa-1-5x link m-1 text-info"
            aria-hidden="true"
            v-on:click="visualizarApensado(subtable.itemData)"
          ></i>
        </template>
      </data-table-consulta-comp>

      <div class="row btnAcoes">
        <button class="btn btn-outline-primary" @click.prevent="atribuirPara"> Atribuir</button>
      </div>
    </div>

    <modal ref="atribuirParaModal" width="1000px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="titulo">Atribuir</h4>
          <i class="fa fa-times fa-1-5x" @click="$refs.atribuirParaModal.closeModal()"/>
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body">
          <atribuirModal :rowsNumber="10" :closeModalEvent="$refs.atribuirParaModal.closeModal"
                         :eventBusModal="eventBusModal"/>
        </div>
      </template>
    </modal>

    <modal ref="armazenarProtocolo" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="text-primary m-3">Armazenar protocolo</h4>
          <i class="fa fa-times fa-1-5x m-2 link" @click="$refs.armazenarProtocolo.closeModal()"/>
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body text-md-left text-sm-center">
          <label>Localização:</label>
          <input class="form-control mb-1" type="text" v-model="armazenamento.local">
          <label>Motivo:</label>
          <textarea class="form-control mb-1" v-model="armazenamento.motivo" rows="5" cols="40"></textarea>
        </div>
        <div class="modal-body text-md-right text-sm-center">
          <button type="button" class="btn btn-outline-danger m-1" @click.prevent="() => {
              $refs.armazenarProtocolo.closeModal()
              limparArmazenamento()
            }">Cancelar
          </button>
          <button type="button" class="btn btn-outline-primary m-1" @click.prevent="armazenar()">Armazenar</button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import filtroPesquisaSetor from '@/components/consulta-processo/FiltroPesquisaSetor.vue'
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsulta'
import VirtusService from '@/services/VirtusService'
import UsuarioService from '@/services/UsuarioService'
import modal from '@/components/shared/Modal'
import atribuirModal from '@/components/setor/AtribuirModal'
import eventBus from '@/uteis/eventBus'

export default {
  name: 'setor',
  components: {
    menuPae,
    filtroPesquisaSetor,
    dataTableConsultaComp,
    modal,
    atribuirModal
  },

  data () {
    return {
      colNames: ['Remetente', 'Nº Protocolo', 'Tipo Protocolo', 'Assunto', 'Interessados', 'Data Envio', 'Ações'],
      eventBusDataName: 'consultaProcessoRecebidosNoSetor',
      eventBusPaginationName: 'consultaProcessoRecebidosNoSetorDataPagination',
      colWidth: [15, 10, 15, 20, 20, 10, 10],
      dataTableColumn: ['atributos.origem.titulo',
        {
          column: 'processo',
          converter: 'protocolo'
        },
        'atributos.tipoProtocolo',
        'atributos.assunto',
        {
          column: 'atributos.interessados.[nome]',
          converter: 'interessados'
        },
        {
          column: 'ultimaTramitacao.data',
          converter: 'localDate'
        }],
      eventBusModal: 'closeModalDevolverProcessos',
      armazenamento: {
        local: '',
        motivo: '',
        numeroProcesso: '',
        nomeUsuario: '',
        usuarioCriacao: ''
      },
      subtable: {
        field: 'processosApensados',
        column: [
          {
            $set: 'Apenso'
          },
          {
            column: 'protocolo',
            converter: 'protocolo'
          },
          'tipoProtocolo',
          'assunto', {
            column: 'interessados.[nome]',
            converter: 'interessados'
          }
        ]
      }
    }
  },

  created () {
    this.service = new VirtusService()
    this.usuarioService = new UsuarioService()
    eventBus.$on(this.eventBusModal, () => {
      this.atualizarConsulta()
    })
  },

  destroyed () {
    eventBus.$off(this.eventBusModal)
  },

  methods: {
    abrirModalArmazenamento (obj) {
      this.armazenamento.numeroProcesso = obj.processo
      this.$refs.armazenarProtocolo.openModal()
    },

    armazenar (obj) {
      const dadosSessao = this.$store.getters.getDadosSessao
      this.armazenamento.usuarioCriacao = dadosSessao.sessao.login
      this.armazenamento.nomeUsuario = dadosSessao.sessao.nomeUsuario
      this.service.armazenar(this.armazenamento).then(res => {
        this.limparArmazenamento()
        this.$refs.armazenarProtocolo.closeModal()
        this.atualizarConsulta()
      }).catch(err => {
        console.log(err)
      })
    },

    limparArmazenamento () {
      this.armazenamento.local = ''
      this.armazenamento.motivo = ''
      this.armazenamento.numeroProcesso = ''
      this.armazenamento.nomeUsuario = ''
      this.armazenamento.usuarioCriacao = ''
    },

    desarmazenar (obj) {
      this.service.desarmazenar(obj.processo).then(res => {
        this.atualizarConsulta()
      }).catch(err => {
        console.log(err)
      })
    },

    visualizarApensado (obj) {
      var data = obj.data
      var disable = true
      this.$store.commit('MUT_COMPONENT_VISIBLE_PROPS', {
        volume: data.tipoProtocolo === 'Processo',
        anexar: true,
        protocoloTipoProcesso: data.tipoProtocolo === 'Processo'
      })
      this.$router.push({
        name: 'visualizadorProcesso',
        query: {
          numeroProcesso: data.protocolo.replace(/\//g, ''),
          disableMenuProcesso: disable,
          tramitado: true
        }
      })
    },

    visualizar (obj) {
      var disable = this.disableMenuProcesso(obj)
      this.$store.commit('MUT_COMPONENT_VISIBLE_PROPS', {
        volume: obj.atributos.tipoProtocolo === 'Processo',
        anexar: true,
        protocoloTipoProcesso: obj.atributos.tipoProtocolo === 'Processo',
        editarProtocolo: obj.atributos.tipoProtocolo === 'Processo'
      })
      this.$router.push({
        name: 'visualizadorProcesso',
        query: {
          numeroProcesso: obj.processo.replace(/\//g, ''),
          disableMenuProcesso: disable,
          anableButtonEditar: obj.atributos.tipoProtocolo === 'PROCESSO',
          tramitado: true
        }
      })
    },

    atribuirPara () {
      const processosSelecionados = this.$store.getters.getDataTableChecked
      if (processosSelecionados.length > 0) {
        this.$refs.atribuirParaModal.openModal()
      }
    },

    devolver () {
      const processosSelecionados = this.$store.getters.getDataTableChecked
      if (processosSelecionados.length > 0) {
        this.$refs.modalName.openModal()
      }
    },

    tramitar () {
      const processosSelecionados = this.$store.getters.getDataTableChecked
      if (processosSelecionados.length > 0) {
        var numeroProcessos = processosSelecionados.map((data) => data.data.processo)
        this.$store.commit('MUT_PROCESSOS_TRAMITACAO', numeroProcessos)
        this.$router.push({ name: 'tramite' })
      }
    },

    async desatribuir (processo) {
      const dadosSessao = this.$store.getters.getDadosSessao
      await Promise.all([
        this.service.desatribuirProcessos(processo, dadosSessao.sessao),
        this.service.registrarDesatribuicaoNoHistorico(dadosSessao.sessao, processo)
      ])
        .catch(err => console.error(err))

      this.atualizarConsulta()
    },

    atualizarConsulta () {
      eventBus.$emit(this.eventBusPaginationName, 1, 'RESET_SELECTED')
    },

    disableButtomVisualizar (obj) {
      return obj.atributos
    },

    disableCheckbox (protocolo) {
      if (!protocolo.data) {
        return false
      }

      if (this.isAtribuido(protocolo.data)) {
        return false
      }

      var apensado = this.isApensado(protocolo.data) !== undefined
      var anexado = this.isAnexado(protocolo.data) !== undefined
      var disable = !(apensado || anexado)
      return disable
    },

    disableAction (protocolo) {
      if (!protocolo.atributos) {
        return false
      }

      var apensado = this.isApensado(protocolo)
      var anexado = this.isAnexado(protocolo)
      var atribuido = this.isAtribuido(protocolo)
      var disable = !(apensado || anexado || !atribuido)
      return disable
    },

    disableMenuProcesso (protocolo) {
      if (!protocolo.atributos) {
        return false
      }

      var apensado = this.isApensado(protocolo)
      var anexado = this.isAnexado(protocolo)
      var atribuido = this.isAtribuidoUsuario(protocolo)
      var arquivado = this.isArquivado(protocolo)
      var disable = (apensado || anexado || !atribuido || arquivado)
      return disable
    },
    isApensado: (obj) => obj.apensadoEm && obj.apensadoEm !== '',
    isAnexado: (obj) => obj.anexadoEm && obj.anexadoEm !== '',
    isArmazenado: (obj) => obj.atributos.armazenado,
    isArquivado: (obj) => obj.atributos.arquivado,
    isAtribuido (obj) {
      const participanteAtual = obj.participanteAtual
      return participanteAtual.tipoIdentificador !== 'ID'
    },
    isAtribuidoUsuario (obj) {
      const sessao = this.$store.getters.getDadosSessao.sessao
      const participanteAtual = obj.participanteAtual
      return participanteAtual.tipoIdentificador === 'LOGIN' && participanteAtual.identificador === sessao.login
    }
  }
}
</script>

<style scoped lang="scss">

.interessadosHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: .75rem;
  background-color: rgba(213, 228, 251, 1);

  .titulo {
    color: #0962BD;
    margin: 10px;
  }

  i {
    color: red;
  }
}

.interessadosFooter {
  display: flex;
  justify-content: flex-end;

  .btn {
    margin-left: 5px;
    margin-right: 10px;
  }
}
</style>
